// extracted by mini-css-extract-plugin
export var active = "Menu-module--active--aYO_r";
export var item = "Menu-module--item--DDbJ8";
export var link = "Menu-module--link--3lstV";
export var list = "Menu-module--list--1n4ZI";
export var menu = "Menu-module--menu--3SbXJ";